import { CreateInvoiceDto, Invoice } from "../../types/invoice.types";
import { PaginationInputDto } from "../../model/common/PaginatedInputDto";
import { get, post, del, patch } from "../../utils/BaseService";
import { GetPaginatedInvoiceDto } from "../../dtos/invoice/GetPaginatedInvoiceDto";
import { ReportRequestDto } from "../../types/report.types";

export async function getAllInvoices(dispatch: any, props: GetPaginatedInvoiceDto) {
  return await post(dispatch, '/invoices/getAllInvoices', props);
}

export async function getInvoiceById(dispatch: any, id: string) {
  return await get(dispatch, `/invoices/getInvoiceById/${id}`, null);
}

export async function createInvoice(dispatch: any, props: CreateInvoiceDto) {
  return await post(dispatch, "/invoices/createInvoice", props);
}

export async function updateInvoiceStatus(dispatch: any, id: string, statusData: any) {
  return await post(dispatch, `/invoices/updateInvoiceStatus/${id}`, statusData);
}

export async function recordPayment(dispatch: any, id: string, paymentDetails: any) {
  return await post(dispatch, `/invoices/${id}/payments`, paymentDetails);
}

export async function deleteInvoice(dispatch: any, id: string) {
  return await del(dispatch, `/invoices/deleteInvoice`, parseInt(id));
}

export async function sendInvoice(dispatch: any, id: string, emailDetails: any) {
  return await post(dispatch, `/invoices/${id}/send`, emailDetails);
}

export async function downloadInvoice(dispatch: any, id: string, format: string = 'pdf') {
  return await get(dispatch, `/invoices/${id}/download`, { format });
}

export async function cloneInvoice(dispatch: any, id: string) {
  return await post(dispatch, `/invoices/${id}/clone`, {});
}
export async function updateInvoice(dispatch: any, input: any,id:number) {
  return await post(dispatch, `/invoices/updateInvoice/${id}`,input);
}
export async function getInvoiceByClientId(dispatch: any, input: PaginationInputDto,id:number) {
  return await post(dispatch, `/invoices/getInvoiceByClientId/${id}`,input);
}
export async function getAllInvoicesByClientId(dispatch: any,input:ReportRequestDto) {
  return await post(dispatch, `/invoices/getAllInvoicesByClientId`,input);
}

export async function removeRecordPayment(dispatch: any, id: number) {
  return await del(dispatch, `/invoices/removeRecordPayment`, id);
}

export async function writeOffInvoice(dispatch: any, id: string, reason: string) {
  return await post(dispatch, `/invoices/writeOff/${id}`, { reason });
}
export async function getDefaultSequence(dispatch: any) {
  return await get(dispatch, `/sequence/getDefaultSequence`,null);
}
export async function isDuplicateInvoiceNumberExist(dispatch: any,invoice_number:string) {
  return await get(dispatch, `/invoices/isDuplicateInvoiceNumberExist`,{invoice_number:invoice_number});
}